module.exports = __webpack_public_path__ + "static/media/Blockchain-overview.4fea9e37.png";